<template>
  <div>
    <mdb-card class="mb-4 text-left">
      <mdb-card-header class="text-center"><h3>🏅 Scoreboard</h3></mdb-card-header>
      <mdb-card-body>
        <div v-if="currentState.iAmModerator" class="text-info">
          <p>
            Give everyone a moment to look at the results. When everyone
            is ready, press "Continue Game" below to give control to the next
            moderator.
          </p>
        </div>
        <mdb-tbl responsive striped>
          <mdb-tbl-head class="primary-color text-white">
            <tr>
              <th>Player</th>
              <th class="text-right">Round Score</th>
              <th class="text-right">Total Score</th>
              <th>Answer</th>
              <th>Voted For</th>
            </tr>
          </mdb-tbl-head>
          <mdb-tbl-body>
            <tr v-for="(player,i) in currentState.players" :key="i" class="mb-2">
              <td><h5>{{ player.name }}</h5>
                <div v-if="currentState.moderator == player.playerId" class="text-info"><i>Round Moderator</i></div>
              </td>
              <td class="text-right">{{ player.roundScore }}</td>
              <td class="text-right"><h5>{{ player.score }}</h5></td>
              <td v-if="player.currentAnswer">
                {{ displayAnswer(player.currentAnswer) }}
                <span v-if="currentState.currentCard.back == player.currentAnswer">
                  (<b><i>Correct Answer</i></b>)
                </span>
              </td>
              <td v-else>N/A</td>
              <td v-if="player.votedFor">
                {{ player.votedFor }}
              </td>
              <td v-else>N/A</td>
            </tr>
          </mdb-tbl-body>
        </mdb-tbl>
        <div v-if="currentState.iAmModerator" class="text-info">
          <mdb-btn icon="check" @click="nextModerator">Continue Game</mdb-btn>
        </div>
      </mdb-card-body>
    </mdb-card>


  </div>
</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {mdbBtn, mdbCard, mdbCardBody, mdbCardFooter, mdbCardHeader, mdbTbl, mdbTblBody, mdbTblHead,} from 'mdbvue';

export default {
  name: "campfire-scoreboard",
  components: {
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbTbl,
    mdbTblHead,
    mdbTblBody
  },
  props: {
    currentState: {
      type: Object,
      default: null
    },
    game: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
    }
  },
  methods: {
    displayAnswer(a) {
      if (!a) return ""
      if (typeof a != "string") return ""
      if (a.substring(0,1) === "[") return ""
      return a


    },
    nextModerator() {
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/nextModerator/" + this.game.sessionId, {
        accessToken: this.game.accessToken
      }).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    }
  }
};
</script>
